export interface Certification {
  name: string;
  issuer: string;
  year: string;
}

export const CERTIFICATIONS: Certification[] = [
  { name: "Azure AZ-900", issuer: "Microsoft", year: "2023" },
  { name: "Google Partner (Google Ads)", issuer: "Google", year: "2020" },
  {
    name: "M101JS: MongoDB for Node.js Developers",
    issuer: "MongoDB University",
    year: "2016",
  },
];
